export default __webpack_public_path__ + "static/media/Ballroll_00211.8be16ab7.png";